import { render, staticRenderFns } from "./CampaignQrSetting.vue?vue&type=template&id=ca2083e2"
import script from "./CampaignQrSetting.vue?vue&type=script&lang=js"
export * from "./CampaignQrSetting.vue?vue&type=script&lang=js"
import style0 from "./CampaignQrSetting.vue?vue&type=style&index=0&id=ca2083e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports